import styled from 'styled-components';

import { Button as CommonButton } from '@rewardopl/react-ui/button/index.styles';

export const Button = styled(CommonButton)`
  display: inline-block;
  background: black;
  color: white;

  &:hover, &:focus {
    background: #333;
    color: white;
  }

  &:focus-visible {
    background: #333;
    color: white;
  }
`;

export const Icon = styled.img`
  width: 20px;
  height: 20px;
  position: relative;
  top: -1px;
  margin-right: 12px;
  vertical-align: -26%;
`;
